<template>
  <div>
    <v-row>
      <v-col cols="2">
        <v-autocomplete
          hide-details
          dense
          outlined
          v-model="record.Category"
          :items="categories"
          label="Category"
          item-text="Name"
          item-value="id"
        ></v-autocomplete>
      </v-col>

      <v-col cols="3">
        <v-autocomplete
          hide-details
          dense
          outlined
          v-model="record.Brand"
          :items="brands"
          label="Company / Brand"
          item-text="Name"
          item-value="id"
        ></v-autocomplete>
      </v-col>

      <v-col cols="3">
        <v-btn color="accent" :loading="loader" @click="getReport">Filter Data</v-btn>
         <v-btn icon @click="print">
          <v-icon>mdi-printer</v-icon>
        </v-btn>
      </v-col>


      <v-col cols="8">
        <v-text-field v-model="search" label="Search" dense></v-text-field>
        <v-data-table dense :items-per-page="1000" :headers="headers" :items="stockReport" :search="search">
        </v-data-table>
        <!-- snackbar -->
        <snackbar ref="snackbar"></snackbar>
      </v-col>
    </v-row>

    <v-row>
      <v-col cols="4">
        <v-text-field label="Total Qty" v-model="availableQty" dense filled outlined readonly></v-text-field>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import jsPDF from "jspdf";
import "jspdf-autotable";
export default {
  data() {
    return {
      record: {},
      search: null,
      loader: false,
      brands: [],
      stockReport: [],
      categories: [],
      reportData: {},
      headers: [
        { text: "Product", value: "product.Name" },
        { text: "Available Qty", value: "AvailableQty" }
      ],
    };
  },
  computed: {
    storeName() {
      return localStorage.getItem("storeName");
    },
    stockValue() {
      let total = 0;
      if (this.reportData.StockValue) {
        total = this.reportData.StockValue.toLocaleString();
      }
      return total;
    },
    availableQty() {
      let total = 0;
      if (this.reportData.TotalAvailableQty) {
        total = this.reportData.TotalAvailableQty.toLocaleString();
      }
      return total;
    },
  },
  methods: {
    getCategories() {
      const self = this;
      this.$store
        .dispatch("get", `/products-categories`)
        .then((res) => {
          if (res.ResultCode == 1200) {
            self.categories = res.ResponseData;
          } else {
            this.$refs.snackbar.show(res.msg, "red");
          }
        })
        .catch((err) => {
          this.$refs.snackbar.show(err, "red");
        });
    },
    getBrands() {
      const self = this;
      this.$store
        .dispatch("get", `/brands`)
        .then((res) => {
          if (res.ResultCode == 1200) {
            self.brands = res.ResponseData;
          } else {
            this.$refs.snackbar.show(res.msg, "red");
          }
        })
        .catch((err) => {
          this.$refs.snackbar.show(err, "red");
        });
    },
    getReport() {
      const url = "/items-total-value";
      const data = this.record;
      const self = this;
      this.loader = true;
      this.$store
        .dispatch("post", { data, url })
        .then((res) => {
          if (res.ResultCode == 1200) {
            self.reportData = res.ResponseData;
          } else {
            this.$refs.snackbar.show(res.msg, "red");
          }
          self.loader = false;
        })
        .catch((err) => {
          this.$refs.snackbar.show(err, "red");
        });
    },
    print() {
      const shopName = this.storeName;
      var doc = new jsPDF({ compress: true });
      var totalPagesExp = "{total_pages_count_string}";
      // var pageHeight =
      //   doc.internal.pageSize.height || doc.internal.pageSize.getHeight();
      var pageWidth =
        doc.internal.pageSize.width || doc.internal.pageSize.getWidth();

      var img = new Image();
      img.src = require("@/assets/stock.png");
      doc.addImage(img, "png", 10, 5, 100, 40);

      doc.setFontSize(15);
      doc.setTextColor(0, 0, 0);
      doc.setFont("Georgia, serif");
      doc.text(shopName, pageWidth - 50, 15, "center");

      //Setting Items Title:
      doc.setFontSize(15);
      doc.text("Available Stock Report", pageWidth / 2, 57, "center");

      doc.setFontSize(13);
      doc.text(
        "From: " + "2020-10-01" + "   " + "To: " + "2020-10-15",
        pageWidth / 2,
        62,
        "center"
      );
      doc.setFontSize(12);

      // Vairables to Hold Data
      let dataRows = [];
      let dataSummaryRows = [];

      // Columns
      var columns = [
        { title: "Product", dataKey: "Name" },
        { title: "Available Qty", dataKey: "AvailableQty" }
      ];

      function dataSummaryColumns() {
        return [
          {
            count: "",
            name: "Amount",
          },
        ];
      }

      const availableQty = {
        count: "Total Available Qty",
        name: this.availableQty,
      };

      dataSummaryRows.push(availableQty);

      doc.setTextColor(0, 0, 0);
      doc.setFontSize(11);
      doc.setFont("Georgia, serif");
      doc.text("SUMMARY", 15, 68);
      doc.autoTable({
        head: dataSummaryColumns(),
        body: dataSummaryRows,
        theme: "grid",
        tableWidth: 80,
        columnStyles: {
          count: {
            fontStyle: "bold",
          },
        },
        startY: 70,
        styles: { overflow: "hidden", cellPadding: 1, font: "Georgia, serif" },
        margin: { right: 100 },
      });

      const allData = this.reportData.AllItems;
      dataRows = allData.map((alldata) => {
        return {
          Name: alldata.product.Name,
          AvailableQty: alldata.AvailableQty,
          AvgBuyingPrice: alldata.AvgBuyingPrice.toLocaleString(),
          rowTotalValue: alldata.rowTotalValue.toLocaleString(),
        };
      });

      doc.setTextColor(0, 0, 0);
      doc.setFontSize(11);
      doc.setFont("Georgia, serif");
      doc.text("RECORDS", 15, doc.autoTable.previous.finalY + 8);
      doc.autoTable(columns, dataRows, {
        theme: "grid",
        startY: doc.autoTable.previous.finalY + 13,
        didDrawPage: function (data) {
          // Header
          doc.setFontSize(20);
          doc.setTextColor(40);

          // Footer
          var str = "Page " + doc.internal.getNumberOfPages();
          // Total page number plugin only available in jspdf v1.0+
          if (typeof doc.putTotalPages === "function") {
            str = str + " of " + totalPagesExp;
          }
          doc.setFontSize(10);

          // jsPDF 1.4+ uses getWidth, <1.4 uses .width
          var pageSize = doc.internal.pageSize;
          var pageHeight = pageSize.height
            ? pageSize.height
            : pageSize.getHeight();
          doc.text(str, data.settings.margin.left, pageHeight - 10);
          //Setting Foouter
          doc.setTextColor(22, 160, 133);
          doc.setFontSize(10);
          var today = new Date();
          doc.text("" + today, pageWidth / 2, pageHeight - 5, "center");
        },
      });
      // Total page number plugin only available in jspdf v1.0+
      if (typeof doc.putTotalPages === "function") {
        doc.putTotalPages(totalPagesExp);
      }
      doc.save("Stock-value-report.pdf");
    },
  },
  created() {
    this.getCategories();
    this.getBrands();
    this.getReport();
  },
};
</script>

<style lang="scss" scoped>
</style>